<template>
  <section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-radio-group v-model="tableData.chooseRadio">
          <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
            @row-click="handleRowClick"
          >
            <!-- 选择框 -->
            <el-table-column v-if="!isRadio" type="selection" width="55" />
            <!-- 选择框 end -->
            <el-table-column v-if="isRadio" width="55" label="选择">
              <template slot-scope="scope">
                <el-radio
                  :disabled="radioDisabled(scope.row)"
                  :label="scope.row[tableData.selectTar]"
                >&nbsp;</el-radio>
              </template>
            </el-table-column>
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
            >
              <section slot-scope="scope">
                <slot name="tableSlot" :column="scope.column" :row="scope.row" />
              </section>
            </el-table-column>
          </el-table>
        </el-radio-group>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    fnRadioDisabled: {
      type: Function,
    },
    handleResParams: {
      type: Function,
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    tableTitle: {
      type: Array,
      default: () => ([]),
    },
    getListApi: {
      type: Function,
    },
    tableSelectTar: {
      type: String,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: this.tableSelectTar,
        chooseRadio: '', // 单选选择
        selectResult: [], // 表格选中的结果
        title: this.tableTitle,
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    async getList (params) {
      const res = await this.getListApi(params);
      if (this.handleResParams) {
        this.handleResParams(res);
      }
      return res;
    },
    radioDisabled (item) {
      if (this.fnRadioDisabled) {
        return this.fnRadioDisabled(item);
      } else {
        return false;
      }
    },
    handleRowClick (item) {
      if (this.fnRadioDisabled) {
        const res = this.fnRadioDisabled(item);
        if (!res) {
          this.tableData.chooseRadio = item[this.tableSelectTar];
        }
      } else {
        this.tableData.chooseRadio = item[this.tableSelectTar];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
